import { get } from 'lodash'
import { required, email } from 'utils/validation'

export default function(values) {
  return {
    email: email(get(values, 'email')),
    secondaryEmail: email(get(values, 'secondaryEmail')),
    tertiaryEmail: email(get(values, 'tertiaryEmail')),
    address: {
      line1: required(get(values, 'address.line1')),
      stateOrProvinceOrRegion: required(
        get(values, 'address.stateOrProvinceOrRegion')
      ),
      country: {
        id: required(get(values, 'address.country.id'))
      }
    }
  }
}
